module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chtitle1"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('span', {
    staticClass: "textStyle9"
  }, [_vm._v("CHAPTER TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "textStyle10"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "textStyle11"
  }, [_vm._v("HE YOUNG MAN")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("who faced Ambrose Quince across the desk in the Theobald’s Road office looked exactly as Lord Charlton had predicted—the very epitome of a rising young American executive. He was clean shaven, blue eyed, and he wore his dark blond hair neatly trimmed. He was dressed in dark gray double-knit woolen pants, a navy-blue blazer, a spotless white shirt, and a club tie. When he smiled, he showed even white teeth, and he obviously used all the right deodorants and mouthwashes.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Ambrose regarded him with very little enthusiasm, uncomfortably aware of his own crumpled suit and the small egg stain on his tie. He said. “So you claim to be Simon Warwick, do you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("The young man smiled. “I am Simon Warwick, Mr. Quince. I can prove it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I’m glad to hear that,” said Ambrose dryly. “Do you have your passport with you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("The smile deepened, attractively. “Certainly.” The visitor reached into his breast pocket and pulled out a United States passport, which he handed to Ambrose.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("The solicitor ruffled through the pages in silence, and then said, “This passport is made out to Harold R. Benson, Jr., born on October 28, 1944, in Leesburg, Virginia. I don’t see any mention of Simon Warwick, Mr. Benson.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Would you expect to, sir?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Ambrose resented being called “sir” by a man of his own age. He said, “I am asking the questions, Mr. Benson. May I ask where you saw our advertisement?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Certainly you may. In the")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Washington Post.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("As a matter of fact, it was my wife who noticed it. She has more time to read the papers, now that Hank is away at school all day.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Hank?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Our son. Harold R. Benson the Third. He’s eight.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“And how did Mrs. Benson know that she was, in fact, married to Simon Warwick?” Ambrose used the tone of voice that he employed in court when trying to unsettle a witness.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("He was rewarded with a smile so broad as to be almost a chuckle. “Mr. Quince, wouldn’t it be easier if I just told you the story of my life—documented where necessary?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Very well.” Ambrose sat back, put the tips of his fingers together, and tried to look inscrutable. In fact, he was trying to make up his mind about the personable Mr. Benson, and failing. “Let’s have it, then. From the beginning.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Again the smile. “A pleasure, Mr. Quince. I was born here in London in 1944. My father was Dominic Warwick, younger brother of the late Lord Charlton. My mother was his wife, née the Honorable Mary Cheverton. I was only a week old when our house was hit by a flying bomb. Both my parents were killed. By some miracle, I survived. I was taken to Great Ormond Street Hospital for Children. Say, does that place still exist?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“It does,” said Ambrose.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Then I shall pay it a visit and shake it by the hand.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Get on with the story, please,” said Ambrose.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Well, my birth had been registered, although I was never christened.” Like a conjurer producing a rabbit from a hat, Benson whisked a yellowing piece of paper out of his pocket and threw it on the desk. “Here’s a copy of the birth certificate. Simon Alexander Warwick, born October 8, 1944.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Not October 28, Mr. Benson?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Obviously not.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“How do you account for the discrepancy?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I’ll come to that later.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Where were you born?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“What do you mean, Mr. Quince? I’ve told you. London.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Ambrose leaned forward. “At home, or in a hospital?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Benson’s brows drew together in a slight frown. “I don’t know,” he said. “She never told me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“She?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“My mother. That is, my adoptive mother. Maybe she didn’t know herself. I’ve always imagined that it was at home.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Home being where?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“London, of course.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“The address?” Ambrose permitted himself a touch of sharpness.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Benson said, “Can’t you read? It’s there on the certificate. 23, Markham Mews, S.W. What I can’t tell you for sure is whether I was born there or in a hospital.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“All right,” said Ambrose. He felt he had been put in a one-down position. “Get on with it. What happened then?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“What happened then was that my father and mother—the Bensons, I mean—were contacted by a lawyer, offering me for adoption.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Name of the lawyer?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I’m sorry. I don’t know.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Ambrose wrote on his pad, “Doesn’t know name of lawyer.” He said, “Where did this anonymous lawyer have his place of business, Mr. Benson?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I don’t know that, either.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Ambrose made another note. Benson, apparently impatient, said, “Hell, Mr. Quince, I’m just telling you what my mother told me. I can’t be expected to know any more, can I?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I suppose not. Who was your adoptive father?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Harold Raymond Benson, Captain, United States Army. Married, in England in 1943, Joan Margaret Wheatley. You’ll find all the papers you need here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Out came another envelope. Very slowly and deliberately, Ambrose Quince inspected the various certificates. Then he said, “I see that both your parents are dead.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Unfortunately, yes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“There is a birth certificate here. Harold Raymond Benson, Jr. Born October 28, 1944, Leesburg, Virginia. It doesn’t tally, does it, Mr. Benson?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Benson said, “My adoptive parents wanted me to have a completely fresh start in life. They regarded my true date of birth as the date when they first took possession of me—if that’s the right expression. October 28. All three of us arrived in the United States on November 7, after a slightly scary voyage—or so I’m told. My parents went to my father’s home in Leesburg, and registered my birth there. I don’t know just how they managed it, but they did it. My father’s family was…well, quite influential. You see, they never wanted me or anybody else to know that I was not their son.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Really?” said Ambrose. “Then how did you come to find out?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I was hoping you would ask me that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Well?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I found this.” Producing his trump card, Harold Benson laid a faded British passport on the desk. It had been issued in London, on October 28, 1944, and was in the name of Simon Alexander Warwick, infant. Blue eyes, fair hair. A pudgy little baby face, surrounded by lace and knitting, gazed peacefully out from the two-by-two-inch photograph. Date of birth, October 8, 1944. Place of birth, London. Nationality, British.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Sharply, Ambrose said, “Where did you get this?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I told you, sir. I found it among my father’s papers, after he died. The birth certificate was with it. It didn’t mean anything to me, of course—that is, I didn’t connect it with myself. I took it to my mother, and asked her who the hell this Simon Warwick was.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“And what did she say?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“She was very upset. If she hadn’t been…if she’d just said it was a friend’s child, or something…I mightn’t have given it another thought. But she hit the ceiling. Said Dad should have destroyed all the documents years ago, that it could only make trouble, and so forth. Well, naturally that got me interested—especially as this Simon Warwick was almost exactly the same age that I was.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“How old were you when this happened, Mr. Benson?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I was fifteen. A bad age. A bad age to lose one’s father. A bad age for a kid to start suspecting that he may never have been that father’s son. I’m not proud of what I did. My mom was upset enough at Dad’s death—it was a heart attack, completely unexpected. I’m afraid I bullied her and shouted at her, and in the end she told me the truth. That I was adopted. That I had been born Simon Warwick, in London. That she knew she could never have children of her own, so she and Dad took me over when my real parents were killed in a raid on London. I made her tell me everything she knew about my real parents—which wasn’t much apart from their names and their address. One thing I never could get out of her was the name of the attorney who had arranged the adoption. She said he was probably still alive, and she would only tell me about dead people, because she said they couldn’t be hurt.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Ambrose said, “How did you react to all this?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“At first I was pretty well broken up. It’s…well, it’s unsettling to find out you’re not the person you thought you were. Kids worry about that sort of thing. But after a bit—well, I guess I just learned to live with it. Pretty soon afterward I went away to college in D.C.—George Washington University. My mother sold the old house and went to live in an apartment. I didn’t see that much of her, I’m afraid. I wasn’t even home when she died. I kept the documents, but I never told anybody who I really was—except my wife, when we got engaged. I reckoned she had the right to know whom she was marrying. That’s how she came to spot the ad in the")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("Post")]), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v(".”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Ambrose considered for a moment. Then he said, “Your mother sold the house. So you don’t still live in Leesburg, Virginia?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Oh, no. We’re in Charlottesville now. Because of the university.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I’m afraid, Mr. Benson,” said Ambrose, “that my knowledge of American geography is limited. Would you explain?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Benson smiled again. He said, “I should have thought that even…that is, the University of Virginia is not exactly unknown outside the States. Thomas Jefferson founded it in Charlottesville in 1819, after he retired—he lived nearby at Monticello. He designed most of the principal buildings himself. The Rotunda—”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I just asked for an explanation, Mr. Benson, not a history lesson.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Sorry, sir. Well, I teach at the university, you see. English literature is my subject. So of course we live in Charlottesville.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I see. Now, you say you have known for some years that you were Simon Warwick. Did you also know that you were Lord Charlton’s nephew?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Benson flushed. “Of course not. I told you, my mother would only mention people who were dead when she told me about my real family. And since my uncle changed his name when he got his peerage, it never even occurred to me—until I saw the story in the papers.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Ambrose said, “The connection between the late Lord Charlton and Simon Warwick was only publicized some days after the original advertisement. I notice that you made no attempt to get in touch with me until you realized that a considerable amount was at stake.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Angrily, Benson said, “I know nothing about what’s at stake. Only rumors. I came here as quickly as I could, after Sally spotted the ad. I couldn’t leave the university until the Christmas vacation.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“You didn’t think of writing to us?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“No, I didn’t. It would have been a waste of time. I obviously had to show you the documents, and I certainly wasn’t about to send them through the mail.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("For a moment, the two men looked at each other with unfriendly eyes. Then Quince said, “Well, of course, all this will have to be checked out, Mr. Benson. I’m sure you understand that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Of course, Mr. Quince.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“So if you’ll just leave the documents with me—”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I’ll do no such thing, Mr. Quince.” With a swift movement, Benson gathered up the papers and returned them to his pocket. “I have had photocopies made for you. Here.” He opened his slim briefcase and took out an envelope. “You’ll find everything there. The passport has been copied page by page, even though most of them are blank. You’ll see the U.S. visa, the exit stamp from the United Kingdom on October 30, 1944, and the entry into the United States on November 7. It was a long trip. The convoy was attacked by U-boats and a couple of the merchant ships were damaged and slowed us all down. That’s what my mother told me. You can probably check that out as well.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Ambrose decided not to make an issue of it. He inspected the contents of the envelope in silence, and then said, “Yes, everything seems to be here. This will do for our preliminary investigations. Where are you staying, Mr. Benson?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“The Marlow Court Hotel in Kensington, sir.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Ambrose produced an icy smile. “We will be in touch, Mr. Benson.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“How long is all this going to take, Mr. Quince? I mean, the Christmas vacation ends on—”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Ambrose stood up. “I’m afraid, Mr. Benson, that we cannot hurry our investigation. However, it may not be necessary for you to stay in the country. We can always contact you in…er…Charlottetown.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Charlottesville, Mr. Quince. But don’t worry, I shall stay here. The university will give me leave of absence.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Ambrose inclined his head slightly. “As you wish, Mr.")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Benson. You will be hearing from us.”")])]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "scale10",
    attrs: {
      "alt": "chpt_fig_001",
      "src": "Images/chpt_fig_001.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Rosalie Quince leaned forward and peered intently into the mirror as she applied dark brown mascara to her long lashes. She said, “What do you think, Ambrose? Can he possibly be genuine?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Ambrose, struggling to make a perfect butterfly bow out of his black tie, said, “I don’t believe him. He’s a fake.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“What makes you so sure, darling?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Because he’s so damned plausible, that’s why.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Rosalie laughed. “That’s a paradoxical reason for not believing him, isn’t it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“He’s exactly the sort of man old Charlton")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("expected")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("to turn up,” said Ambrose. He gave his tie a sharp tweak, and it came undone. “Damn this thing. Then there’s the American birth certificate and the wrong date of birth. The whole story stinks.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Rosalie regarded her beautiful, pale reflected face, and made a moue. “I wish I didn’t have to wear this awful old rag tonight. Prudence always has such marvelous clothes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“You look lovely, darling,” said Ambrose gallantly.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Oh, don’t be idiotic.” Rosalie gave her shoulders a little, impatient shake, and arranged the slim straps of her dress. “What about the passport? How could he possibly have got the passport unless he was Simon Warwick? Doesn’t that make it fairly conclusive?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Not if I can help it,” Ambrose said. “Come and tie this bloody thing for me, will you, darling?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Okay.” Rosalie’s deft fingers flickered, and the black silk fell obediently into shape. “Did Michael say who else is going to be there tonight?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Just himself and Prudence and one other couple. People by the name of Tibbett. He’s some sort of big noise at Scotland Yard. They’re old friends of the Barkers’—you know how many police prosecutions Michael does.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Rosalie said, “Well, perhaps this Tibbett can help you explode your fake Simon Warwick. If he is a fake.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“And if he’s not—”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Come on, Ambrose. We’re late already and it’s a filthy night. Why does it always have to rain on Christmas Eve?”")])]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "scale10",
    attrs: {
      "alt": "chpt_fig_001",
      "src": "Images/chpt_fig_001.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Prudence and Michael Barker were celebrated for their small dinner parties, but they had had no intention of giving one on Christmas Eve. Their idea had been to share a quiet meal with their old friends, Chief Superintendent Henry Tibbett of Scotland Yard and his wife, Emmy. In fact, it had become something of a tradition over the past few years. Christmas is a time for family reunions, but the Tibbetts were childless and the three Barker girls were grown, married, and widely scattered over the world. So the Tibbetts and the Barkers had fallen into the pleasant habit of dining together on Christmas Eve, and Prudence had issued the expected invitation in mid-December.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Michael Barker was surprised, therefore, to get a telephone call from Henry on December 21.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Michael? Henry here. Look, old man—I wonder if I might ask a favor of you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“A favor? Of course. What is it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“You know Ambrose Quince, don’t you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Yes. Not very well. His father and mine were friends. Is it about this Simon Warwick business? Nothing criminal there, I hope.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“No, no,” said Henry. “It’s just that…well, I’d like to meet him.” He hesitated. “You…I hate to ask you this, Michael…you wouldn’t invite them on Christmas Eve, would you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Michael was taken aback. “Well…I suppose we could…doubt if they’d be able to come at such short—”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Henry said, “I really can’t explain, Michael. It’s just that my…that these Simon Warwick advertisements have interested me. There’s a great deal of money involved, you know, and also control of a very important group of companies.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“And a peerage?” said Michael.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“No—Charlton was a life peer. Fortunately. Otherwise, it would have been a situation of comic-opera complexity. Will you apologize to Prue and humor me, Michael? I’d really like to meet Quince, in a purely social situation.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Oh, very well. I’ll give him a call now. I suppose he’ll have to consult with Rosalie and ring us back.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Later that evening, Prudence Barker answered the telephone.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Oh, hello…yes…yes…yes, that’s right…good…about seven-thirty…see you then…” She put down the receiver, and said to her husband, “The Quinces will be delighted to come on Wednesday.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Well, I’m damned,” said Michael Barker. “I never thought—”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Almost certainly,” said Prudence, “Rosalie will have had to cancel something else. But she would never refuse an invitation from you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“It was from you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Don’t be silly. It was from us, to dine at this house. You are a Queen’s Counsel and therefore socially desirable. It’s a pity, because I like Rosalie in many ways. I just wish she wasn’t so blatantly ambitious. It makes me feel…exploited.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I’m the one who should feel exploited,” said Michael. “It was Henry who insisted we ask the wretched Quinces.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Then,” said Prudence, “Henry will have had a good reason. Let’s make it a good party.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("To everybody’s surprise, it was a good party. Rosalie Quince, despite her old dress, looked exquisite and behaved beautifully. Emmy Tibbett, merry and dark haired and fighting a losing battle with plumpness, put everybody at their ease by her genuine pleasure in meeting new acquaintances. Henry, mild mannered and sandy haired, encouraged Ambrose Quince to expand his sense of importance. Prudence served simple, excellent food and Michael excellent and rather expensive wine. As coffee was served, the conversation inevitably turned to the topic of Simon Warwick.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Ambrose, mellow with wine, was prepared to regard this as a privileged occasion, and lowered his normally rigid defenses.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Yes,” he said, puffing on one of Michael’s cigars. “Yes, it’s an interesting situation. And—just between these four walls—our first client turned up today.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Claiming to be Simon Warwick?” Henry asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“More than claiming. Insisting. With the whole story pat")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle7"
  }, [_vm._v("and")]), _vm._v(" "), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("the original Warwick baby’s passport.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Do you believe him?” Prudence asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Frankly, Mrs. Barker—no, I don’t. But it’s going to be difficult to prove or disprove his claim, one way or the other.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Henry said, “Correct me if I’m wrong, Michael—but I should have thought that this would be a matter for a court to decide. I mean—Charlton’s executors should surely challenge the authenticity of any claimant, however convincing, if only to throw the ball into the lap of the judiciary and force the court to make a ruling.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Of course,” said Michael. “That’s what you are planning, isn’t it, Quince?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Before Ambrose could answer, Rosalie said, “It would be no easier for anybody to substantiate a claim in a court than out of it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“No easier,” said Henry, “but more binding in law, once the decision was given. If Mr. Quince were to decide on his own, as executor, to recognize a claimant—”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I appreciate your good advice, Chief Superintendent,” said Ambrose, with more than a touch of irony. “However, I am not proposing to recognize anybody at this stage. Apart from a few crank letters, we’ve only had this one fellow, and I think we shall be able to dispose of him without too much difficulty.”")])]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('img', {
    staticClass: "scale10",
    attrs: {
      "alt": "chpt_fig_001",
      "src": "Images/chpt_fig_001.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("On December 29, when Messrs. Quince, Quince, Quince and Quince reopened for business after the Christmas holiday, the second claimant turned up.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Simon Finch could hardly have been more different from Harold R. Benson, Jr., if he had been studying for the part. He was a tall, gangling man, untidily put together, with hands and feet that seemed too large for his thin body. His face was long and creased, and his blue eyes were vague behind thick-lensed glasses. His gray pin-striped suit was considerably shabbier than Ambrose’s, and his shirt looked as though it was nearing the end of a week of wear. His shoes were scuffed and his socks, although both blue, did not match. When he spoke, his voice was high pitched and nervous, with a middle-class English accent. Not at all the sort of man who Lord Charlton had hoped would take over the running of his empire.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Mr. Quince?” he said. He threw back his head in a nervous gesture, causing his Adam’s apple to wobble.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I am Ambrose Quince, yes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I’m pleased to meet you, Mr. Quince. I am Simon Warwick.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Ambrose regarded his visitor with disbelief. Then he said. “My secretary announced Mr. Simon Finch.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Well, yes, of course she did. I am Simon Finch. But I am also Simon Warwick. That is, I used to be Simon Warwick.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“How surprising. Can you prove it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Oh yes. Certainly. Of course. I wouldn’t be here otherwise, would I?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Very well,” said Ambrose. “Go ahead. Prove it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I hardly know where to start, Mr. Quince. With my birth, I suppose. My real parents were Lord Charlton’s brother, Dominic Warwick, and his wife, Mary. They were killed in London by a flying bomb when I was a small baby—only a week old, in fact. Neither family wanted me. I imagine that my mother’s people had disapproved of her marriage, and that Alexander Warwick was too busy.” Finch’s thin mouth clamped shut in an expression at once disgusted and deeply hurt.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Go on,” said Ambrose.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Fortunately for me, Alexander Warwick did business with a solicitor in Marstone—one Alfred Humberton. There was a big American military camp near Marstone, and Humberton knew of a certain Captain John Finch and his English wife, who wanted to adopt a baby before going back to the States. Captain Finch had been wounded and was being invalided home. So it was arranged. I traveled with the Finches to America on a British passport in the name of Simon Warwick, but once we got there, I became Simon Finch.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Ambrose had gone rather pale. He said, “How do you know all this?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Finch creased his face into the semblance of a smile. He took an envelope out of his pocket and handed it to the lawyer. “These are photocopies, of course,” he said. “I have the originals. They are the letters Humberton wrote to the Finches.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Ambrose extracted the sheets of stiff photocopy paper from the envelope, and unfolded them. There were three letters, on Humberton’s headed notepaper. The first started, “Dear Captain Finch, I believe I may have found a baby suitable for immediate adoption…” The second was concerned with practical details, and included the sentence, “I have applied for a passport on his behalf…” The last read, “Dear Captain Finch, I am delighted that all is now arranged, and that you and Mrs. Finch will collect the little chap from my office at 2:30 P.M. next Tuesday. I note that you sail on Thursday, and wish you a safe and speedy voyage…” The correspondence appeared to have taken place during the last weeks of October 1944.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Ambrose said, “How did these documents come into your possession, Mr. Finch?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“How? From my parents, of course.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“There is no mention of the name Simon Warwick, Mr. Finch. I suppose you know that Mr. Humberton arranged other private adoptions?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“You think he arranged another adoption that same week, to another American army captain sailing for home with his English wife?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Ambrose let this pass. He said, “How and when did you learn your true identity, Mr. Finch?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Finch said, “When I was fifteen, I happened to find these papers, and realized I was adopted. I persuaded my mother to tell me my real name. She knew it, of course, even though as a matter of policy it was not written in the letters. It was…a traumatic experience, Mr. Quince. As a result, I ran away from home. My childhood had not been very happy, you see.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“It strikes me, Mr. Finch,” said Ambrose, “that you appear to be completely English, rather than American.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“That’s true. My adoptive mother was English, of course, and I have lived in this country since I was fifteen. When I ran away, it was to England.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“You traveled on a United States passport?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Not my own.” Finch paused. “Perhaps I had better explain.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I think you should, Mr. Finch.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Well, at the age of fifteen I visited this country with my parents, traveling with them on a joint family passport. I knew my true identity by then, and I was secretly determined to stay in England. I…acquired…the documents relating to my adoption before we left home. Once here, I persuaded my parents to enroll me at an English school and go home without me. I then ran away from school.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“And they never tried to find you?” Ambrose was incredulous.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“They may have done. They did not succeed. Frankly, I think they were as pleased to be rid of me as I was of them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“And what about your position here? Are you a naturalized Englishman?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Why should I be? I was born here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Ambrose said, impatiently, “You know what I mean. What passport do you hold? Where are your identity documents?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Finch held up a thin hand. “All lawyers are alike. They think only in terms of documents. Ordinary people are simpler. I have no documents, Mr. Quince. I have never applied for a passport. I live my quiet bachelor life in Westbourne, and mind my own business. Should I ever need documents, I would produce the evidence I have shown you, with my birth certificate as Simon Warwick, which is filed at Somerset House. I call myself Simon Finch, because I have become accustomed to the name—but I am Simon Warwick and I have proved it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Your date of birth?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“October 8, 1944. It’s there in one of the letters.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“What happened to the passport issued to you as a baby?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Finch shrugged. “I have no idea. I suppose the Finches destroyed it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Well,” said Ambrose, “the matter can be cleared up quite simply. I will contact Captain and Mrs. Finch. Do you have their address?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“I do not. We have not corresponded for nearly twenty years. The last address I know is the one mentioned in those letters, in McLean, Virginia. I have no idea whether they are still there—or indeed, if they are still alive.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“It’s all very unsatisfactory, Mr. Finch,” Ambrose said. “We shall have to check it out very carefully.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("“Of course you will, Mr. Quince. I suppose you are getting the usual collection of frauds, pretending to be me. But none of them has the documents that I have.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "textStyle6"
  }, [_vm._v("Ambrose stood up. “We have your Westbourne address, Mr. Finch. We will be in touch with you in due course.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-364c1dc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Chapter02.vue
// module id = 78
// module chunks = 0